// Der eine Host für Upgrade- und Limit-Dialog. Gerendert in context/index.js
// direkt unter PaymentContextProvider, geöffnet über usePricingDialog aus
// features/pricing/pricing-dialog-context.js.
//
// Ein einziges Modal mit den Ansichten feature und limit. Der Inhalt hängt an
// requestId, jedes Öffnen beginnt also mit frischem Anfrage-Zustand. Er wird
// erst beim Öffnen gemountet, deshalb lädt der Limit-Dialog nur die Nutzung
// der Ressource, um die es geht.
//
// Liegt in der Kette von context/index.js und importiert deshalb direkt aus
// den Dateien, nie aus features/pricing/index.js.
import {
  PRICING_DIALOG_VIEWS,
  usePricingDialog,
  usePricingDialogState
} from '../../features/pricing/pricing-dialog-context'
import Modal from '../tailwind/Modal'
import LimitDialog from './limit-dialog'
import UpgradeDialog from './upgrade-dialog'

const PricingDialog = () => {
  const dialog = usePricingDialogState()
  const { closePricingDialog } = usePricingDialog()

  if (!dialog.view) return null

  return (
    <Modal
      open={dialog.open}
      setOpen={closePricingDialog}
      size='md'
      padding='p-0'
      borderRadius='rounded-xl'
      hideCloseButton
    >
      {dialog.view === PRICING_DIALOG_VIEWS.LIMIT ? (
        <LimitDialog
          key={dialog.requestId}
          resource={dialog.key}
          source={dialog.source}
          context={dialog.context}
          onClose={closePricingDialog}
        />
      ) : (
        <UpgradeDialog
          key={dialog.requestId}
          featureKey={dialog.key}
          source={dialog.source}
          inUse={!!dialog.context?.inUse}
          onClose={closePricingDialog}
        />
      )}
    </Modal>
  )
}

export default PricingDialog
